import { DatePicker } from 'antd'
import styled from 'styled-components'
import { NumberField } from 'sutra/components/NumberField/NumberField'
import { Select } from 'sutra/components/Select/Select'
import { semantic } from 'sutra/tokens/colors'

export const Section = styled.div`
  margin-bottom: 4px;
`

/** Matches the export modal's section labels (export/styles.ts) so the two surfaces read as one system. */
export const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${semantic.fgMuted};
  margin-bottom: 8px;
`

export const Divider = styled.div`
  height: 1px;
  background: #f0f0f0;
  margin: 16px 0;
`

export const ToggleList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`

export const DateFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

// 24px matches the neighbouring antd `size="small"` date pickers.
export const PresetSelect = styled(Select)`
  width: 170px;
  && {
    height: 24px;
  }
` as typeof Select

export const SingleDatePicker = styled(DatePicker)`
  width: 160px;
` as typeof DatePicker

export const CountInput = styled(NumberField)<{ $width: number }>`
  width: ${({ $width }) => $width}px;
`

export const CountControls = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  flex-wrap: nowrap;
`

export const BetweenInputs = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const BetweenSep = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  flex-shrink: 0;
`

export const ClearLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  color: #1677ff;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: #4096ff;
    text-decoration: underline;
  }
`

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`

export const ClearAllButton = styled.button`
  padding: 5px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color: #40a9ff;
    border-color: #40a9ff;
  }
`

export const ApplyButton = styled.button`
  padding: 5px 16px;
  border: none;
  border-radius: 6px;
  background: #1677ff;
  color: white;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #4096ff;
  }
`
